import React from "react"
import { RichTextRenderer } from "components/Contentful/RichTextRenderer"
import { ButtonCta } from "packages/acquisition/components/chakra-components/CMS/ButtonCta"
import type { BannerCTA, CountDownRefType } from "types/cms"
import type { Document } from "@contentful/rich-text-types"
import type { CMSPageProps } from "packages/acquisition/components/chakra-components/LandingPage/LandingPage.utils"
import { RichTextFlat } from "packages/acquisition/shared/components/Contentful/RichTextFlat"
import { SubHeading } from "../SubHeading"
import { CountDown } from "../CountDown"

import {
  mobileTextContent,
  mobileDisplay,
  richTextContainer,
} from "./MobileContent.css"

import { textPaddings } from "../common.css"

const defaultBodyContent = {
  nodeType: "document",
  data: {},
  content: [
    {
      nodeType: "paragraph",
      data: {},
      content: [
        { nodeType: "text", value: "Body Content", marks: [], data: {} },
      ],
    },
  ],
}

type Props = CMSPageProps & {
  bannerCta: BannerCTA
  bodyCopy: Document | string
  countdown?: CountDownRefType
  desktopContentAlignment: "Left" | "Right" | "Center"
  fontColor: string
  modulePosition: number
  showSubHeadingOnImageInMobileView?: boolean
  subHeading?: string
  showBodyCopy?: boolean
}

export const MobileContent: React.FC<Props> = ({
  bannerCta,
  bodyCopy,
  countdown,
  desktopContentAlignment,
  fontColor,
  modulePosition,
  showSubHeadingOnImageInMobileView,
  subHeading,
  trackingModule,
  showBodyCopy,
}) => {
  const containerClass = `${mobileTextContent} ${
    textPaddings[desktopContentAlignment ?? "Left"]
  }`
  return (
    <div className={containerClass}>
      {!showSubHeadingOnImageInMobileView && subHeading && (
        <SubHeading
          subHeading={subHeading}
          modulePosition={modulePosition}
          color={fontColor}
        />
      )}
      {showBodyCopy !== false && (
        <div className={richTextContainer}>
          {typeof bodyCopy === "string" ? (
            <RichTextFlat content={bodyCopy} />
          ) : (
            <RichTextRenderer content={bodyCopy || defaultBodyContent} />
          )}
        </div>
      )}
      {countdown && (
        <div className={mobileDisplay}>
          <CountDown countdownData={countdown} />
        </div>
      )}
      {bannerCta && (
        <ButtonCta
          trackingModule={trackingModule}
          {...bannerCta}
          buttonProps={{
            w: { base: "100%", md: "fit-content" },
            mt: "1rem",
          }}
        />
      )}
    </div>
  )
}
